"use client";

import { useEffect } from "react";

export const HEADER_HIDDEN_CLS = "mode-hidden";
export function HeaderInteractions() {
  useEffect(() => {
    let prevScroll = 0;
    let $h: HTMLElement | null;
    const onScroll = () => {
      if (!$h) {
        $h = document.getElementById("xHeader");
      }
      const currentScroll = window.scrollY;
      if (currentScroll <= 0) {
        //一番上
        if ($h?.dataset.mode === "episode") {
          //viewerが存在する場合は一番上でヘッダを隠す
          if (prevScroll > 0 && document.getElementById("comici-viewer")) {
            $h?.classList.add(HEADER_HIDDEN_CLS);
          }
        } else {
          $h?.classList.remove(HEADER_HIDDEN_CLS);
        }
      } else if (prevScroll <= currentScroll) {
        //順スクロール
        $h?.classList.add(HEADER_HIDDEN_CLS);
      } else {
        //逆スクロール
        $h?.classList.remove(HEADER_HIDDEN_CLS);
      }
      prevScroll = currentScroll;
    };
    window.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  });
  return <></>;
}
